export default "__VITE_ASSET__1aa48cf1__"